const normalizeLinkValue = (value) => (typeof value === "string" ? value.trim() : value)

const firstPresentValue = (...values) => values.find((value) => value !== null && value !== undefined && value !== "")

export const getStoryblokLink = ({ href, anchor, linktype, cached_url, cachedUrl, url, story, email } = {}) => {
  const cleanHref = normalizeLinkValue(href)
  const cleanAnchor = normalizeLinkValue(anchor)
  const cleanCachedUrl = normalizeLinkValue(cached_url)
  const cleanCachedUrlCase = normalizeLinkValue(cachedUrl)
  const cleanUrl = normalizeLinkValue(url)
  const cleanEmail = normalizeLinkValue(email)
  const storySlug = normalizeLinkValue(story?.slug)
  const storyUrl = normalizeLinkValue(story?.url)
  const storyFullSlug = normalizeLinkValue(story?.full_slug)

  // Asset Link
  if (linktype === "asset" && (cleanUrl || cleanHref)) return cleanUrl || cleanHref

  // Email Link
  if (linktype === "email") return `mailto:${cleanEmail || cleanUrl || cleanHref}`

  if (linktype === "story" && storySlug === "home") return storyUrl

  // Internal Link
  if (linktype === "story" && storyFullSlug) return `${storyFullSlug.startsWith("/") ? "" : "/"}${storyFullSlug}`

  // Defined URL. Can be external or internal
  if (linktype === "url" && (cleanUrl || cleanHref)) return cleanUrl || cleanHref

  // inline links
  // if a link is inline within a rich text field then an href will be provided
  if (cleanHref !== null && cleanHref !== undefined && cleanHref !== "") return cleanHref

  // internal link
  // cached_url can be undefined if an internal link field is left blank
  if (linktype === "story" && cleanCachedUrl !== "" && cleanCachedUrl !== undefined) {
    return cleanAnchor ? `/${cleanCachedUrl}#${cleanAnchor}` : `/${cleanCachedUrl}`
  }

  // Don't ask me why, but Storyblok is inconsistent with this property's case.
  if (cleanCachedUrl || cleanCachedUrlCase || cleanHref) {
    return firstPresentValue(cleanCachedUrl, cleanCachedUrlCase, relativizeToBase(cleanHref))
  }

  return ""
}

const isRelative = (str) => !/^(?:[a-z+]+:)?\/\//.test(str)

// find only scheme/protocol-free relative URLs without forward slash and add them.
const relativizeToBase = (href) => {
  return href && isRelative(href) && (href.startsWith("/") ? href : `/${href}`)
}
